/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as api from '../../epics/api';

const propTypes = {
    freelancerAvailability: PropTypes.object,
};

const availabilityPeriodsMap = {
    early_morning: '02:00 \u2013 07:00',
    morning: '07:00 \u2013 12:00',
    afternoon: '12:00 \u2013 17:00',
    evening: '17:00 \u2013 22:00',
    night: '22:00 \u2013 02:00',
};

class FreelancerDetailsAvailability extends Component {
    constructor(props) {
        super(props);
        this.days = [
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday',
        ];
        this.periods = [
            'early_morning',
            'morning',
            'afternoon',
            'evening',
            'night',
        ];
        this.state = {
            isEdit: false,
            isLoading: false,
            fields: {},
        };
    }

    handleEditButtonClick = () => {
        this.setState({
            isEdit: true,
        });
    };

    handleCancelButtonClick = () => {
        this.setState({ isEdit: false });
    };

    handleCheckboxFieldChange = (event, fieldName) => {
        this.setState({
            fields: {
                ...this.state.fields,
                [fieldName]: event.target.checked,
            },
        });
    };

    handleSaveButtonClick = () => {
        this.setState({ isLoading: true });
        api.executeHttpRequest(
            `freelancers/${this.props.freelancerData.id}/availability/`,
            'patch',
            {
                ...this.state.fields,
            },
        )
            .then(res => {
                this.props
                    .fetchFreelancerAvailabilityAsync(
                        this.props.freelancerData.id,
                    )
                    .then(res => {
                        this.setState({ isLoading: false, isEdit: false });
                    });
            })
            .catch(err => {
                this.setState({ isLoading: false, isEdit: false });
            });
    };

    renderRows() {
        const { freelancerAvailability } = this.props;
        const { isEdit, isLoading, fields } = this.state;
        if (freelancerAvailability) {
            return this.periods.map(period => (
                <tr key={period}>
                    <td>{availabilityPeriodsMap[period]}</td>
                    {this.days.map(day => {
                        const isAvailable =
                            freelancerAvailability[`${day}_${period}`];
                        const inputName = `${day}_${period}`;
                        const classNames = [
                            'table-default__cell--align-center',
                            isAvailable
                                ? 'table-default__cell--text-green'
                                : 'table-default__cell--text-red',
                        ];
                        return isEdit ? (
                            <td key={day} className="center">
                                <input
                                    className="checkbox-purple"
                                    name={inputName}
                                    type="checkbox"
                                    checked={
                                        typeof this.state.fields[inputName] !==
                                        'undefined'
                                            ? this.state.fields[inputName]
                                            : isAvailable
                                    }
                                    onChange={event => {
                                        this.handleCheckboxFieldChange(
                                            event,
                                            inputName,
                                        );
                                    }}
                                />
                            </td>
                        ) : (
                            <td key={day} className={classNames.join(' ')}>
                                <i
                                    className={
                                        isAvailable
                                            ? 'icon icon-check-12'
                                            : 'icon icon-close2'
                                    }
                                />
                            </td>
                        );
                    })}
                </tr>
            ));
        }
    }

    render() {
        const { isEdit, isLoading, fields } = this.state;
        const { editionEnabled } = this.props;

        return (
            <div className="freelancer-details-section">
                <div className="freelancer-details-section__header">
                    <div className="freelancer-details-section__title">
                        Availability
                    </div>
                    {editionEnabled &&
                        (isEdit ? (
                            <div className="freelancer-details-section__btns">
                                <button
                                    disabled={isLoading}
                                    className="freelancer-details-section__btn"
                                    onClick={this.handleSaveButtonClick}
                                >
                                    Save
                                </button>
                                <button
                                    disabled={isLoading}
                                    className="freelancer-details-section__btn"
                                    onClick={this.handleCancelButtonClick}
                                >
                                    Cancel
                                </button>
                            </div>
                        ) : (
                            <div className="freelancer-details-section__btns">
                                <button
                                    className="freelancer-details-section__btn"
                                    onClick={this.handleEditButtonClick}
                                >
                                    <i className="icon icon-pencil-3" />
                                    Edit availability
                                </button>
                            </div>
                        ))}
                </div>
                <div className="freelancer-details-section__content">
                    <table className="table-default">
                        <tbody>
                            <tr>
                                <td />
                                <td className="table-default__cell--text-blue table-default__cell--align-center">
                                    Mon
                                </td>
                                <td className="table-default__cell--text-blue table-default__cell--align-center">
                                    Tue
                                </td>
                                <td className="table-default__cell--text-blue table-default__cell--align-center">
                                    Wed
                                </td>
                                <td className="table-default__cell--text-blue table-default__cell--align-center">
                                    Thu
                                </td>
                                <td className="table-default__cell--text-blue table-default__cell--align-center">
                                    Fri
                                </td>
                                <td className="table-default__cell--text-blue table-default__cell--align-center">
                                    Sat
                                </td>
                                <td className="table-default__cell--text-blue table-default__cell--align-center">
                                    Sun
                                </td>
                            </tr>
                            {this.renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

FreelancerDetailsAvailability.propTypes = propTypes;

export default FreelancerDetailsAvailability;
